const config = [
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '项目概况',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '公告信息',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
]
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
  data() {
    return {
      config: JSON.parse(JSON.stringify(config)),
    }
  },
  methods: {
    getData() {
      this.$request.post(`/transformToAfter/app/home/bqGongshiXX.do`, {
        gsGuid: this.$route.query.ggGuid,
      }, { showLoading: true }).then((res) => {
        this.config[1].options.data = {
          '项目名称': res.data.gcName,
          '项目编号': res.data.gcBH,
          '采购方式': getPurchaseTypeName(res.data.zbFangShi),
          '业主单位': res.data.zbRName,
        }
        this.config[3].options.data = {
          '公告标题': res.data.gsTitle,
          '公告发布时间': this.$util.getTime(res.data.faBuTime, 'YYYY-MM-DD'),
          '反馈截至时间': this.$util.getTime(res.data.feedbackEndTime, 'YYYY-MM-DD'),
          '联系人': res.data.contactUserName,
          '联系电话': res.data.contactUserPhone,
          'html_公告内容': res.data.gsContent,
        }
      })
    },
  },
}

module.exports = {
  config,
  mixin,
}
